import classNames from 'classnames';
import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import mapProps from 'recompose/mapProps';
import Layout from '@4c/layout';

import withReservation from '../utils/Reservation';
import Card from './Card';
import FormattedPrice from './FormattedPrice';
import { BilledAnnually } from './PriceFootnotes';
import Total from './Total';
import Text from './Text';

const Price = mapProps(p => ({
  ...p,
  children:
    p.value == null ? (
      p.emptyValue || '$0.00'
    ) : (
      <FormattedPrice value={p.value} />
    ),
}))(styled('span', null, "Price", require("./OrderSummary-Price.module.scss"), "price", "price"));

const LineItem = styled('span', null, "LineItem", require("./OrderSummary-LineItem.module.scss"), "line-item", "lineItem");

const Quantity = styled('span', null, "Quantity", require("./OrderSummary-Quantity.module.scss"), "quantity", "quantity");

const styles = require('./OrderSummary-styles.module.scss');

const propTypes = {};

function OrderSummary({ cart, className, totalsOnly, ...props }) {
  return (
    <Card {...props} className={classNames(styles.card, className)}>
      {!totalsOnly && (
        <>
          <Card.Segment>
            <Card.Heading>
              <FormattedMessage
                defaultMessage="Order Summary"
                id="orderSummary.title"
              />
            </Card.Heading>
          </Card.Segment>

          {!!cart.numDevicesLightning && (
            <Card.Segment pad={3} noBorder>
              <Quantity>{cart.numDevicesLightning}</Quantity>
              <Layout.Block grow>
                <Layout direction="column">
                  <div>
                    <Text level="3" bold>
                      <FormattedMessage
                        defaultMessage="Butterfly iQ"
                        id="orderSummary.iq"
                      />
                    </Text>
                  </div>
                  <div>
                    <FormattedMessage
                      defaultMessage="Lightning"
                      id="orderSummary.iq.lightning"
                    />
                  </div>
                </Layout>
              </Layout.Block>
              <Price value={cart.devicesLightningPrice} />
            </Card.Segment>
          )}
          {!!cart.numDevicesUsbC && (
            <Card.Segment pad={3} noBorder={!cart.numDevicesLightning}>
              <Quantity>{cart.numDevicesUsbC}</Quantity>
              <Layout.Block grow>
                <Layout direction="column">
                  <div>
                    <Text level="3" bold>
                      <FormattedMessage
                        defaultMessage="Butterfly iQ"
                        id="orderSummary.iq"
                      />
                    </Text>
                  </div>
                  <div>
                    <FormattedMessage
                      defaultMessage="USB-C"
                      id="orderSummary.iq.usbc"
                    />
                  </div>
                </Layout>
              </Layout.Block>
              <Price value={cart.devicesUsbCPrice} />
            </Card.Segment>
          )}
          <Card.Segment pad={3}>
            <Quantity />
            <Layout.Block as={LineItem} grow>
              <FormattedMessage
                defaultMessage="{years} Year Warranty"
                id="orderSummary.warranty"
                values={{ years: cart.warrantyYears }}
              />
            </Layout.Block>

            {cart.extendedWarrantiesPrice ? (
              <Price value={cart.extendedWarrantiesPrice} />
            ) : (
              <FormattedMessage
                tagName="span"
                defaultMessage="Included"
                id="orderSummary.warrantyIncluded"
              />
            )}
          </Card.Segment>
          {!cart.remote.isDeviceOnly && (
            <Card.Segment pad={3}>
              <Quantity>{1}</Quantity>
              <Layout.Block grow>
                <LineItem>
                  <FormattedMessage
                    defaultMessage={`{plan, select,
                  TEAM {Team Subscription:}
                  INDIVIDUAL {Individual Subscription:}
                  }
                `}
                    id="orderSummary.plan"
                    values={{
                      plan: cart.plan,
                      users: cart.numCloudUsers,
                      br: <br />,
                    }}
                  />
                </LineItem>
                <br />
                <FormattedMessage
                  defaultMessage={`{users} {users, plural,
                  one {user}
                  other {users}
                }`}
                  id="orderSummary.numUsers"
                  values={{ users: cart.numCloudUsers }}
                />
                <br />
                <BilledAnnually parens />
              </Layout.Block>
              <Price value={cart.cloudUsersPrice} />
            </Card.Segment>
          )}
          {cart.cloudDicom && cart.plan === 'TEAM' && (
            <Card.Segment pad={3}>
              <Quantity />
              <Layout.Block grow as={LineItem}>
                <FormattedMessage
                  defaultMessage="DICOM Connector"
                  id="orderSummary.dicom"
                />
              </Layout.Block>
              <Price value={0} />
            </Card.Segment>
          )}
        </>
      )}
      <Card.Segment direction="column" pad={4}>
        <Layout justify="space-between">
          <span>
            <FormattedMessage
              defaultMessage="Subtotal"
              id="orderSummary.subtotal"
            />
          </span>

          <Price strong value={cart.subtotal} />
        </Layout>
        <Layout justify="space-between">
          <span>
            <FormattedMessage
              defaultMessage="Shipping"
              id="orderSummary.shipping"
            />
          </span>

          <Price strong value={cart.shippingPrice} emptyValue="$—" />
        </Layout>
        <Layout justify="space-between">
          <span>
            <FormattedMessage defaultMessage="Tax" id="orderSummary.tax" />
          </span>

          <Price strong value={cart.taxPrice} emptyValue="$—" />
        </Layout>
      </Card.Segment>
      <Card.Segment justify="space-between">
        <span className={styles.total}>
          <FormattedMessage
            defaultMessage="Order Total"
            id="orderSummary.total"
          />
        </span>

        <Total value={cart.total} />
      </Card.Segment>
    </Card>
  );
}

OrderSummary.propTypes = propTypes;

export default withReservation(OrderSummary);
